export type ThreePlReportId =
  | 'shipped_orders'
  | 'shipped_orders_sales'
  | 'shipped_orders_refund_payments'
  | 'invoice_audit'
  | 'active_clients';

export type ThreePlReportParamType = 'date_range' | 'invoice_id' | 'none';

export interface ThreePlReportDefinition {
  id: ThreePlReportId;
  titleKey: string;
  descriptionKey: string;
  paramType: ThreePlReportParamType;
}

export const THREE_PL_EXCEL_REPORTS: ThreePlReportDefinition[] = [
  {
    id: 'shipped_orders',
    titleKey: 'reports.shipped_orders.title',
    descriptionKey: 'reports.shipped_orders.description',
    paramType: 'date_range',
  },
  {
    id: 'shipped_orders_sales',
    titleKey: 'reports.shipped_orders_sales.title',
    descriptionKey: 'reports.shipped_orders_sales.description',
    paramType: 'date_range',
  },
  {
    id: 'shipped_orders_refund_payments',
    titleKey: 'reports.shipped_orders_refund_payments.title',
    descriptionKey: 'reports.shipped_orders_refund_payments.description',
    paramType: 'date_range',
  },
  {
    id: 'invoice_audit',
    titleKey: 'reports.invoice_audit.title',
    descriptionKey: 'reports.invoice_audit.description',
    paramType: 'invoice_id',
  },
  {
    id: 'active_clients',
    titleKey: 'reports.active_clients.title',
    descriptionKey: 'reports.active_clients.description',
    paramType: 'none',
  },
];
